// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#quantityControl[data-v-079679fc]{border:1px solid var(--border-color);border-radius:5px;box-shadow:none;display:block;font-size:20px;height:calc(1.5em + .75rem + 6px);line-height:22px;margin-right:10px;outline:none;padding:.375rem .75rem;width:60px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
